import { ErrorModel, ErrorModelFromJSON, ResponseError } from '../clients'

export const getErrorModel = async (err: Error): Promise<ErrorModel | null> => {
    const e = err as ResponseError
    try {
        const j = await e.response.json()
        const m = ErrorModelFromJSON(j)
        if (m.errors?.length || m.detail) {
            return m
        }
    } catch {
        return null
    }
    return null
}